module.exports = __webpack_public_path__ + "img/Nosotros 768px.36331732.png";